/**
 * <s-card-media> — Keeps a product card's photo dots in sync with its swipeable photo track.
 *
 * Required child markup:
 *   [data-card-media-track] — Horizontal scroll-snap track holding one photo per slide.
 *   [data-card-media-dots]  — Container whose children are the dots; the current one gets data-active.
 */
class CardMedia extends HTMLElement {
  #ac = null;
  #frame = 0;

  connectedCallback() {
    const track = this.querySelector('[data-card-media-track]');
    const dots = this.querySelector('[data-card-media-dots]');
    if (!track || !dots) return;

    this.#ac = new AbortController();
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(this.#frame);
      this.#frame = requestAnimationFrame(() => this.#update(track, dots));
    }, { passive: true, signal: this.#ac.signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
    cancelAnimationFrame(this.#frame);
  }

  #update(track, dots) {
    const width = track.clientWidth || 1;
    const index = Math.round(Math.abs(track.scrollLeft) / width);
    Array.from(dots.children).forEach((dot, i) => {
      dot.toggleAttribute('data-active', i === index);
    });
  }
}

if (!customElements.get('s-card-media')) {
  customElements.define('s-card-media', CardMedia);
}
